import { configureStore } from '@reduxjs/toolkit';
import userReducer from './modules/user';
import postsReducer from './modules/posts';
import notificationsReducer from './modules/notifications';

const store = configureStore({
  reducer: {
    // 用户模块
    user: userReducer,
    posts: postsReducer,
    notifications: notificationsReducer,
  },
});

export default store;
